import { DragDropUpload } from "@/components/ui/DragDropUpload";
import { convertToCSV, downloadCSV, parseCSV } from "@/utils/csv-utils";

const CSV_HEADERS = [
  "storyType",
  "category",
  "subcategory",
  "gender",
  "numberOfPages",
  "pageSize",
  "promptName",
  "promptRevision",
  "count",
  "modelName",
  "imagePromptName",
  "imagePromptRevision",
  "configRevision",
];

type Props = {
  onDataParsed: (data: Record<string, string>[]) => void;
};

export function CSVUpload({ onDataParsed }: Props) {
  function onCSVUpload(files: File[]) {
    const fileReader = new FileReader();
    fileReader.onload = () => {
      if (typeof fileReader.result !== "string") {
        console.error("file content is not text!");
        return;
      }
      const parsedData = parseCSV(fileReader.result);
      onDataParsed(parsedData);
    };
    fileReader.readAsText(files[0]);
  }

  function onCSVDownload() {
    const csv = convertToCSV(CSV_HEADERS, []);
    downloadCSV("story-generator", csv);
  }

  return (
    <DragDropUpload
      label="Drag and drop CSV file with stories to generate"
      loading={false}
      onFilesUpload={onCSVUpload}
      secondaryActionLabel="Download template"
      onSecondaryAction={onCSVDownload}
    />
  );
}
